
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impact-analysis-continous/create",
      function () {
        return require("private-next-pages/impact-analysis-continous/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impact-analysis-continous/create"])
      });
    }
  